


























import Vue from 'vue'
import LabeledButtonWithDialog from '../buttons/LabeledButtonWithDialog.vue'
import OpenDialog from "../dialogs/OpenDialog.vue"
import ShareDialog from "../dialogs/ShareDialog.vue"
import NewDialog from "@/components/dialogs/NewDialog.vue";

export default Vue.extend({
  name: 'PanelLeft',
  components: {
    LabeledButtonWithDialog,
    NewDialog,
    OpenDialog,
    ShareDialog
  }
})
